import styled from "styled-components";

export const RabbitFestivalEventWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 150px;
`;
